import type { Schema } from "../types";

export const table: Schema = {
	children: ["table"],
};
